import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEmployeeStore } from "presentation/stores/use-employee-store";
import { useFilterEmployeeStore } from "presentation/stores/use-filter-employee-store";
import { translateText } from "infra/translation/translate";

interface ParamProps {
  query?: {};
  exportExcel?: () => void;
  exportPdf?: () => void;
}

const HeaderEmployeeGrid: React.FC<ParamProps> = ({ query, exportExcel, exportPdf }) => {
  const [globalFilterValue, setGlobalFilterValue] = useState<string>("");
  const { filters, setFilters, resetFilters } = useFilterEmployeeStore();
  const navigate = useNavigate();
  const { resetEmployee } = useEmployeeStore();

  const clearFilter = () => {
    resetFilters();
    setGlobalFilterValue("");
    setFilters({
      query: { value: "", matchMode: "contains" },
      employeeNumber: { value: "", matchMode: "equals" },
      name: { value: "", matchMode: "contains" },
      jobTitle: { value: "", matchMode: "equals" },
      contractType: { value: "", matchMode: "equals" },
      isActive: { value: "", matchMode: "equals" },
    });
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      let _filters = { ...filters, limit: 1 };
      // @ts-ignore
      _filters["query"].value = globalFilterValue;
      setFilters(_filters);
    }
  };

  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGlobalFilterValue(e.target.value);
  };

  const addEmployee = () => {
    resetEmployee();
    navigate("/employees/new", {state: {canEdit: true}});
  };

  useEffect(() => {
    if (filters.query.value !== globalFilterValue) {
      setGlobalFilterValue(filters.query.value);
    }
  }, [filters]);

  return (
    <div className="flex justify-content-between">
      <div>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            onKeyDown={onKeyDown}
            placeholder={translateText("Search", "pt")}
          />
        </IconField>
      </div>
      <div style={{ display: "flex", gap: "10px" }}>
        <Button
          type="button"
          icon="pi pi-file-excel"
         
          rounded
          onClick={() => {
            console.log(' Botão Excel clicado no header');
            if (exportExcel) {
              exportExcel();
            } else {
              console.error(' exportExcel não está definida');
            }
          }}
          tooltip="Exportar para Excel"
        />
        <Button
          type="button"
          icon="pi pi-file-pdf"
         
          rounded
          onClick={() => {
            console.log(' Botão PDF clicado no header');
            if (exportPdf) {
              exportPdf();
            } else {
              console.error(' exportPdf não está definida');
            }
          }}
          tooltip="Exportar para PDF"
        />
        <Button
          type="button"
          icon="pi pi-plus"
          label={
            translateText("New", "pt") + " " + translateText("Employee", "pt")
          }
          outlined
          onClick={addEmployee}
          style={{
            backgroundColor: "#2196F3",
            color: "white",
            borderRadius: "8px",
          }}
        />
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label={translateText("Clean", "pt")}
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "white",
            borderColor: "#2196F3",
            color: "#2196F3",
            borderRadius: "8px",
          }}
        />
      </div>
    </div>
  );
};
export default HeaderEmployeeGrid;
